import { InitialApprovalDocMasterAmount } from '.';
import { Actions, types } from './actions';

const initialState: InitialApprovalDocMasterAmount = {
  requiredAmount: 0,
  admitAmount: 0,
  resultAmount: 0,
  applicationApprovalReferenceAmount: 0,
};

const reducer = (state = initialState, action: Actions): InitialApprovalDocMasterAmount => {
  switch (action.type) {
    case types.APPROVAL_AMOUNT_SIDEBAR:
      return action.payload;

    default:
      return state;
  }
};

export default reducer;
